import { CHART_COLORS, CHART_PALETTE } from '@/lib/chart-theme'
import { StatCard, fmt$, InfoTooltip } from './shared'

export function ApprovalQueueReport({ data }: { data: any }) {
  const { summary, chartData } = data

  return (
    <div className="rep-report">
      <div className="rep-stats-row">
        <StatCard title="Pending Estimates" value={summary.pendingCount} color={CHART_PALETTE[1]} />
        <StatCard title="Avg Wait" value={`${summary.avgWaitDays} days`} color={CHART_COLORS.blue} />
        <StatCard title="Pending Value" value={fmt$(summary.totalPendingValue)} />
      </div>

      <div className="rep-charts-row">
        <div className="rep-chart-card rep-chart-full">
          <InfoTooltip text="A heatmap grid shows approval wait times as color intensity — longer waits get darker cells, making bottlenecks and patterns jump out visually." />
          {chartData.items.length > 0 ? (
            <>
              <HeatmapGrid items={chartData.items} />
            </>
          ) : (
            <div className="rep-empty-chart">No estimates pending approval</div>
          )}
        </div>
      </div>

      {chartData.items.length > 0 && (
        <div className="rep-table-card">
          <h3 className="rep-chart-title">Queue Details</h3>
          <table className="rep-table">
            <thead>
              <tr>
                <th>Estimate</th>
                <th>Estimator</th>
                <th>Value</th>
                <th>Days Waiting</th>
              </tr>
            </thead>
            <tbody>
              {chartData.items.map((r: any) => (
                <tr key={r.estimateId}>
                  <td>{r.title}</td>
                  <td>{r.estimator}</td>
                  <td>{fmt$(r.total)}</td>
                  <td>{r.daysWaiting}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

function HeatmapGrid({ items }: { items: any[] }) {
  const maxDays = Math.max(...items.map((i) => i.daysWaiting), 1)

  return (
    <div className="rep-heatgrid">
      {items.map((item, i) => {
        const intensity = Math.min(item.daysWaiting / maxDays, 1)
        // Color scale: 0 days = very light magenta (#F3E8FF), max days = full magenta (#D447FB)
        const bg = `rgba(212, 71, 251, ${0.08 + intensity * 0.55})`
        const textColor = intensity > 0.5 ? '#fff' : 'var(--s800)'

        return (
          <div
            key={i}
            className="rep-heatgrid-cell"
            style={{ background: bg, color: textColor }}
            title={`${item.title} — ${item.daysWaiting} days waiting`}
          >
            <span className="rep-heatgrid-title">{item.title}</span>
            <span className="rep-heatgrid-days">{item.daysWaiting}d</span>
            <span className="rep-heatgrid-sub">{item.estimator}</span>
          </div>
        )
      })}
    </div>
  )
}
